import {
  MCC_DETAIL_REQUEST,
  MCC_DETAIL_REQUEST_SUCCESS,
  MCC_DETAIL_REQUEST_FAILURE,
  MCC_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const mccDetailReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MCC_DETAIL_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MCC_DETAIL_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case MCC_DETAIL_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MCC_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

export default mccDetailReducer;
